import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { message } from 'antd'
import dayjs from 'dayjs'
import React, { useRef } from 'react'

interface StageChangeItemProps {
   item: any
}

export const StageChangeItem: React.FC<StageChangeItemProps> = ({ item }) => {
   const ref = useRef<HTMLDivElement>(null)
   const { data: user } = useAuthUser({ revalidateOnMount: true })

   const getBackgroundColor = () => {
      switch (item.itemActionStatus) {
         case 'LEAD':
            return 'text-[#383A3E]'
         case 'success':
            return 'text-[#55F381]'
         case 'failed':
            return 'text-[#FE6464]'
         default:
            return ''
      }
   }

   const getIntentBackgroundColor = () => {
      if (item.intentType === 'negative' && item.itemType === 'post_analysis') {
         return '!bg-[#D53E59]'
      } else if (
         item.intentType === null &&
         item.itemType === 'post_analysis'
      ) {
         return '!bg-[#643338]'
      }
   }

   const handleCopy = () => {
      navigator.clipboard.writeText(item?.stepId).then(() => {
         message.success('Copied to clipboard')
      })
   }

   return (
      <div
         ref={ref}
         className={` flex justify-between items-center bg-white/5 py-3 px-8 ${getBackgroundColor()} ${getIntentBackgroundColor()}`}
      >
         <div>
            {user?.email === 'operator@forward-flow.com' && item?.stepId && (
               <div className="text-[11px] mb-1 text-white/70 flex gap-x-4">
                  <span
                     className="cursor-pointer select-all"
                     title="Click to copy"
                     onClick={handleCopy}
                  >
                     Step Id:{' '}
                     <span className="text-[12px] font-medium">
                        {item?.stepId}
                     </span>
                  </span>
                  {item?.phase && (
                     <span
                        className="cursor-pointer select-all"
                        title="Click to copy"
                        onClick={handleCopy}
                     >
                        Phase:{' '}
                        <span className="text-[12px] font-medium">
                           {item?.phase}
                        </span>
                     </span>
                  )}
               </div>
            )}
            <p className="text-[12px] font-medium">{item?.content}</p>
         </div>

         <p className="text-[12px] text-white">
            {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
         </p>
      </div>
   )
}
